<template>
  <div class="container fluid">
    <v-card>
      <v-toolbar
        dark
        tabs
        flat
        color="primary white--text"
      >
        <v-toolbar-title class="justify-center">
          <h1 class="display-1 headline text--accent-1">
            Payout Management
          </h1>
        </v-toolbar-title>
        <v-spacer />
      </v-toolbar>
      <v-toolbar
        dark
        tabs
        flat
        color="primary white--text"
        height="72px"
      >
        <v-tabs
          v-model="tab"
          slider-color="amber"
          grow
          color="primary"
          centered
          icons-and-text
        >
          <v-tab
            v-for="(item, id) in tabs"
            :key="id"
            :href="`#${id}`"
          >
            <span>{{ item.title }}</span>
            <v-icon>{{ item.icon }}</v-icon>
          </v-tab>
        </v-tabs>
      </v-toolbar>

      <v-tabs-items v-model="tab">
        <v-tab-item
          v-for="(item, id) in tabs"
          :key="id"
          :value="`${id}`"
        >
          <v-card flat>
            <component :is="item.component" />
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import {
  LegalEntities,
  BankInformations,
  Companies,
} from '@/components/payoutsAndTaxes';

export default {
  name: 'ManagementView',
  components: {
  },
  data() {
    return {
      tab: null,
      tabs: {
        legalEntities: {
          title: 'Legal Entities',
          icon: 'business',
          component: LegalEntities,
        },
        bankInformations: {
          title: 'STO Bank Information',
          icon: 'business',
          component: BankInformations,
        },
        companies: {
          title: 'Companies',
          icon: 'apartment',
          component: Companies,
        },
      },
    };
  },
  computed: {
    currentTabName() {
      if (this.tab === null) {
        return '';
      }

      return `${this.tabs[this.tab].title}`;
    },
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/views/payoutsAndTaxes/management/ManagementView.vue